import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import styles from './customSecondaryCheckBox.module.scss';

export const CustomSecondaryCheckBox = (props) => {
    const [isChecked, setIsChecked] = useState(props.ischecked);
    return (
        <div className={`${styles.defaultCheckBoxMain} ${isChecked ? styles.isCheckedCheckBoxMain : ''}`}>
            <div className='d-flex flex-row'>
                <div className={`${styles.svgDiv} ${isChecked ? styles.isCheckedSvgDiv : ''}`}>
                    {React.cloneElement(props.svg, { stroke: isChecked ? '#2DA6C0' : '#475467' })}
                </div>

                <div className={styles.checkBoxTitle}>
                    {props.label}
                </div>
            </div>

            <div className={styles.checkBoxMain}>
                <input className={styles.checkboxInput}
                    checked={isChecked}
                    onChange={() => {
                        setIsChecked((prev) => !prev);
                        props.handleOnChange(); // Call the handleOnChange function from props
                      }}
                    type="checkbox"
                    value={props.value}
                    />
            </div>
        </div>
    )
}